/**
 * ocbon-lp.js — OCBON Landing Page JS
 * Handles: smooth scroll, product card selection, ATC with cart-drawer, FAQ accordion
 */

(function () {
  'use strict';

  // ─── Smooth Scroll ───────────────────────────────────────────────────────────
  function initScrollCTAs() {
    document.querySelectorAll('[data-scroll-to="offer"]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.querySelector('.olp-offer');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // ─── Product Card Selection ───────────────────────────────────────────────────
  function initProductCards() {
    var cards = document.querySelectorAll('[data-card]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.classList.remove('olp-is-selected'); });
        card.classList.add('olp-is-selected');
      });
    });
  }

  // ─── Add to Cart (Elixir cart-drawer pattern) ────────────────────────────────
  function initATC() {
    var atcBtn = document.querySelector('[data-atc]');
    if (!atcBtn) return;

    atcBtn.addEventListener('click', function () {
      var selectedCard = document.querySelector('[data-card].olp-is-selected');
      if (!selectedCard) return;

      var variantId = selectedCard.getAttribute('data-variant');
      if (!variantId) return;

      atcBtn.disabled = true;
      var originalText = atcBtn.textContent;
      atcBtn.textContent = 'Adding...';

      var body = JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: body,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Network response was not ok');
          return res.json();
        })
        .then(function (parsedState) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.renderContents(parsedState);
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .finally(function () {
          atcBtn.disabled = false;
          atcBtn.textContent = originalText;
        });
    });
  }

  // ─── FAQ Accordion ────────────────────────────────────────────────────────────
  function initFAQ() {
    var items = document.querySelectorAll('[data-faq-item]');
    if (!items.length) return;

    items.forEach(function (item) {
      var btn = item.querySelector('[data-faq-q]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('olp-is-open');

        // Close all
        items.forEach(function (other) {
          other.classList.remove('olp-is-open');
          var q = other.querySelector('[data-faq-q]');
          if (q) q.setAttribute('aria-expanded', 'false');
        });

        // Toggle clicked
        if (!isOpen) {
          item.classList.add('olp-is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  // ─── Init ──────────────────────────────────────────────────────────────────
  function init() {
    initScrollCTAs();
    initProductCards();
    initATC();
    initFAQ();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
